import { createAsyncThunk } from "@reduxjs/toolkit";
import { LoginTeacherWithGoogle } from "../../../apis";
import { parseJwt } from "../../../utils";
import { TEACHER_AUTH } from "../../configs";

export const loginTeacher = createAsyncThunk(
  TEACHER_AUTH,
  async (data, thunkAPI) => {
    try {
      const res = await LoginTeacherWithGoogle(data);
      if (res.status === 200) {
        localStorage.setItem("auth-token", res.data);
        return parseJwt(res.data);
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (e) {
      console.log("Error", e.response.data);
      return thunkAPI.rejectWithValue(e.response.data);
    }
  }
);
